import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { QuillViewComponent } from 'ngx-quill';

@Component({
  selector: 'app-check-box',
  templateUrl: './check-box.component.html',
  styles: [],
  imports: [
    NgbTooltipModule,
    TranslateModule,
    CommonModule,
    QuillViewComponent,
    FormsModule,
  ],
})
export class CheckBoxComponent {
  @Input() elementId: string;
  @Input() content: string;
  @Input() disabled = false;
  @Input() isChecked = false;
  @Input() tooltip: string;
  @Input() labelClass: string;
  @Input() wrapperClass = '';
  @Input() tooltipClass = '';
  @Input() iconClass = '';

  @Output() selectItem = new EventEmitter<boolean>();

  toggle(event: Event): void {
    const value = event.target['checked'];
    this.isChecked = value;
    this.selectItem.emit(value);
  }
}
